export class IncidenceType {

  constructor(
    public code?: number,
    public description?: string,
    public manuallyCreated?: Boolean,
    public isFinished?: Boolean,
    public isRecoverable?: Boolean,
    public isScrapped?: Boolean,
    public isPaused?: Boolean
  ) { }

  clone() {
    return new IncidenceType(
      this.code,
      this.description,
      this.manuallyCreated,
      this.isFinished,
      this.isRecoverable,
      this.isScrapped,
      this.isPaused
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/incidence-type.ts